import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import addon_sensors from '@devices/settings/device_settings/addon_sensors.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import favorites_gen_2 from '@devices/settings/device_settings/favorites_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import roller_app_setting_gen_2 from '@devices/settings/device_settings/roller_app_setting_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

const settings = {
	title: 'settings',
	components: [
		{ title: 'reverse_directions', component: 'reverse_direction_g2' },
		{ title: 'calibration', component: 'calibration_g2' },
		{ title: 'movement_time_limits', component: 'movement_time_limits_g2' },
		{ title: 'action_on_power_on', component: 'action_on_power_on_g2_cover' },
		{ title: 'motor_speed', component: 'motor_speed_g2' },
		{ title: 'gesture_control', component: 'gesture_control_g2' },
		{ title: 'inputs_configuration', component: 'inputs_configuration_g2' },
		{ title: 'device_name', component: 'device_name_g2' },
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};

export default [
	schedule_gen_2,
	webhooks_gen_2,
	addon_sensors,
	scripts_gen_2,
	networks_gen_2_plus,
	bluetooth_gen_2,
	favorites_gen_2,
	virtual_components,
	roller_app_setting_gen_2,
	share,
	settings,
];
